import { Box, Grid, styled } from "@mui/material";
import { Button, Typography } from "@pmag/ui-components";

export const ComponentGroupItem = styled(Grid)(({ theme }) => ({
    width: "100%",
    paddingBottom: theme.spacing(4),
}));

export const ComponentGroupItemInnerContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    background: theme.palette.core.white,
    display: "flex",
    height: "100%",
    boxShadow: theme.shadow.boxShadow.sm,
    borderRadius: theme.shape.borderRadius,
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
        alignItems: "start",
    },
}));

export const ComponentGroupCode = styled(Typography)(({ theme }) => ({
    position: "absolute",
    top: 4,
    left: 4,
    color: theme.palette.core.grey._60,
}));

export const ComponentSubGroupContainer = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
}));

export const ComponentSubGroupButton = styled(Button)(() => ({
    textAlign: "left",
    justifyContent: "flex-start",
}));

export const CardImageContainer = styled(Box)(({ theme }) => ({
    position: "relative",
    marginRight: theme.spacing(2),
    minHeight: 100,
    width: 150,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
